import firebase from '../firebase/compat';

const defaultDates = () => {

    /** Zeroes time to 00:00:00.000 */
    function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
    }

    /** Sets time to 23:59:59.999 */
    function endOfDay(date) {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
    }

    /** Feb 1, 2000 00:00:00.000 */
    const defaultStartDate = firebase.firestore.Timestamp.fromDate(
    startOfDay(new Date(2000, 1, 1))
    );

    /** Today 23:59:59.999 */
    const defaultEndDate = firebase.firestore.Timestamp.fromDate(
    endOfDay(new Date())
    );

    return {
    defaultStartDate,
    defaultEndDate,
}
}

export default defaultDates;